import styled from 'styled-components';
import { withRouter } from 'next/router';
import { object, string, func } from 'prop-types';

import StyledText from '../../components/shared/StyledText';
import RouterLink from '../../components/shared/RouterLink';
import { TABLET_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.div`
  cursor: pointer;
  user-select: none;
  @media (max-width: ${TABLET_SIZE}) {
    display: ${({ isHome }) => isHome && 'none'};
  }
`;

const Logo = ({ fontColor, t, router, onClick }) => (
  <Container isHome={router.pathname === '/'} onClick={onClick}>
    <RouterLink href={`/`}>
      <StyledText size="36px" color={fontColor} isBold>
        {t('COMPONENTS_HEADER_MAIN_TITLE')}
      </StyledText>
    </RouterLink>
  </Container>
);

Logo.propTypes = {
  fontColor: string.isRequired,
  router: object,
  onClick: func,
};

export default withRouter(withI18next()(Logo));



// WEBPACK FOOTER //
// components/Header/Logo.js